export const urlValue = process.env.REACT_APP_IVA_FACTORY_ULR